module.exports = __webpack_public_path__ + "static/og-image-8b8d1e0c029a5ec2525fa482df3738e0.jpg";